import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router";

interface AccessDeniedProps {
  title?: string;
  subTitle?: string;
  redirectPath?: string;
  redirectText?: string;
}

const AccessDenied: React.FC<AccessDeniedProps> = ({
  title = "Access Denied",
  subTitle = "Sorry, you don't have permission to access this page.",
  redirectPath = "/",
  redirectText = "Back to Dashboard",
}) => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px 0",
      }}
    >
      <Result
        status="403"
        title={title}
        subTitle={subTitle}
        extra={
          <Button type="primary" onClick={() => navigate(redirectPath)}>
            {redirectText}
          </Button>
        }
      />
    </div>
  );
};

export default AccessDenied;
